export const nl = {
    nav: {
        home: 'Home',
        support: 'Support',
        inbox: 'Inbox',
        news: 'Nieuws',
        reviews: 'Reviews',
        info: 'Informatie',
        occasions: 'Aanbod',
        damage: 'Schade melden',
        contact: 'Contact',
        profile: 'Mijn gegevens',
        notifications: 'Notificaties',
        chat: 'Chat en hulp',
        appointment: 'Afspraak maken',
        faults: 'Storingen',
        menu: 'Meer',
        logout: 'Uitloggen',
        login: 'Inloggen',
        service_support: 'Service en support',
        information: "Informatiepagina's",
        dropup: {
            profile: 'Mijn gegevens',
            vehicles: 'Mijn voertuigen',
            logout: 'Uitloggen',
            login: 'Inloggen',
            anonymous: 'Annoniem',
        },
        dropdown: {
            profile: 'Mijn gegevens',
            vehicles: 'Mijn voertuigen',
            logout: 'Uitloggen',
            login: 'Inloggen',
            anonymous: 'Annoniem',
        },
    },
    dashboard: {
        titles: {
            vehicles: 'Mijn voertuigen',
            welcome: {
                morning: 'Goedemorgen ',
                afternoon: 'Goedemiddag ',
                welcome_team: 'Team',
                welcome_company: 'staat voor je klaar.',
                nice_day: 'We wensen je een fijne dag. ',
            },
            features: 'Direct naar',
            support: 'Hoi, kan ik je helpen?',
        },
        buttons: {
            vehicles: 'Naar mijn voertuigen',
        },
        widgets: {
            unread_notifications: {
                copy: (args?: Record<string, string>) =>
                    args?.count == '1'
                        ? `Er is ${args?.count} ongelezen notificatie`
                        : `Er zijn ${args?.count} ongelezen notificaties.`,
            },
            unread_messages: {
                copy: (args?: Record<string, string>) =>
                    args?.count == '1'
                        ? `Er is ${args?.count} ongelezen chatbericht`
                        : `Er zijn ${args?.count} ongelezen chatberichten.`,
            },
        },
    },
    notifications: {
        titles: {
            unread: 'Ongelezen',
            read: 'Gelezen',
            vehicles: 'Voor jouw voertuigen',
            general: 'Algemeen',
            empty: 'Er is geen bericht geopend',
        },
        copy: {
            empty: 'Selecteer in de lijst links een bericht',
        },
        buttons: {
            reply: 'Reageer',
            back: 'Alle notificaties',
            make_appointment: 'Afspraak maken',
            open_onboarding: 'Update gegevens',
        },
        default: 'Er staat een bericht voor je klaar in je inbox',
    },
    chat: {
        attach: {
            file: 'Bestand of foto',
            location: 'Locatie',
        },
        placeholder: (args?: Record<string, string>) =>
            `Hoi ${args?.name}! In deze chat kan je gemakkelijk vragen aan ons stellen. We proberen hier binnen 1 werkdag op te reageren.`,
    },
    profile: {
        fields: {
            full_name: 'Voornaam en achternaam',
            name: 'Voornaam',
            preposition: 'Tussen',
            surname: 'Achternaam',
            email: 'Email',
            phone: 'Telefoonnummer',
            birthday: 'Geboortedatum',
            language: 'Taal',
            default_location: 'Voorkeursvestiging',
            street_and_number: 'Straatnaam, huisnummer en toevoeging',
            postal_code: 'Postcode',
            postalcode_and_city: 'Postcode en woonplaats',
            street: 'Straatnaam',
            house_number: 'Nummer',
            house_number_addition: 'Toevoeging',
            city: 'Woonplaats',
            country: 'Land',
            select: {
                language: 'taal',
                default_location: 'vestiging',
            },
        },
        preferences: {
            receive_general_messages: 'Algemeen',
            receive_marketing_messages: 'Marketing',
            receive_service_messages: 'Servive',
            receive_personal_messages: 'Pesoonlijk',
            receive_mail_channel: 'Post',
            receive_phone_channel: 'Telefoon',
            receive_mobile_phone_channel: 'Mobiele telefoon',
            receive_sms_channel: 'SMS',
            receive_whatshapp_channel: 'Whatsapp',
            receive_email_channel: 'E-mail',

            titles: {
                categories: 'Categorieën',
                channels: 'Kanalen',
            },

            notifications: {
                disabled: {
                    title: 'Je hebt niet alle notificaties ingeschakeld',
                    message: 'Check je instellingen en blijf op de hoogte',
                },
            },
        },
        tabs: {
            data: 'Mijn gegevens',
            address: 'Adresgegevens',
            preferences: 'Voorkeuren',
        },
        buttons: {
            save: 'Opslaan',
        },
        titles: {
            other_data: 'Overige gegevens',
        },
    },
    vehicles: {
        tabs: {
            general: 'Algemeen',
            mileage: 'Kilometerstand',
        },
        titles: {
            index: 'Mijn voertuigen',
            other_specs: 'Andere gegevens van jouw ',
            mileage_history: 'Logboek kilometerstanden',
        },
        copy: {
            delete: 'Verwijder mijn voertuig permanent',
            notifications: (args?: Record<string, string>) =>
                args?.count == '1'
                    ? `Er is ${args?.count} ongelezen bericht voor deze ${args?.brand}`
                    : `Er zijn ${args?.count} ongelezen berichten voor deze ${args?.brand}`,
            mileage:
                'Om je zo goed mogelijk van dienst te kunnen zijn vragen we je om onderstaande gegevens te controleren of waar nodig aan te vullen.',
        },
        fields: {
            mileage: 'Kilometerstand',
        },
        labels: {
            lease: 'Dit is een lease auto',
            mileage_added: 'Kilometerstand gerapporteerd',
        },
        specs_grid: {
            catalogue_price: 'Catalogusprijs',
            brand: 'Merk',
            inspection_expiration_date: 'APK datum',
            mileage: 'KM stand',
            buildyear: 'Bouwjaar',
        },
        buttons: {
            add: 'Voertuig toevoegen',
            delete: 'Verwijderen',
            back: 'Mijn voertuigen',
        },
        table: {
            brand: 'Merk',
            model: 'Model',
            buildyear: 'Bouwjaar',
            fuel_type: 'Brandstof',
            color: 'Kleur',
            tires: 'Type banden',
        },
        modals: {
            titles: {
                create: 'Voertuig toevoegen',
                delete: 'Voertuig verwijderen',
                results: 'Zoekresultaten',
            },
            explanations: {
                create: 'Vul hier je kenteken in. Hiermee kunnen we zien met welk voertuig je rijdt en jou automatische berichten sturen om je bijvoorbeeld te herinneren aan de APK.',
                already_exists: 'Dit kenteken is al reeds geregistreerd',
                delete_vehicle: (args?: Record<string, string>) =>
                    `Weet je zeker dat je het voertuig met kenteken ${args?.license_plate} wilt verwijderen?`,
            },
            buttons: {
                search: 'Zoeken',
                delete: 'Verwijderen',
                cancel: 'Annuleren',
            },
            flash: {
                success: 'Het voertuig is toegevoegd',
            },
        },
        defaults: {
            unknown: 'Onbekend',
        },
    },
    damage: {
        titles: {
            index: 'Schade melden',
        },
        copy: {
            index: 'Schade? Dat is vervelend! Wij helpen je. Geen formulieren meer invullen of opsturen. Door digitaal jouw schade te melden handel je dit direct af met jouw verzekeraar of leasemaatschappij.',
        },
        links: {
            open_damage_form: 'Open online schadeformulier',
            start_chat: 'Start een gesprek',
        },
    },
    faults: {
        titles: {
            index: 'Storingen',
            support: 'Pech onderweg of behoefte aan support?',
        },
        copy: {
            index: 'Wat betekend dat storingslampje nu? Selecteer je voertuig en zie wat de storingslampjes betekenen.',
        },
        buttons: {
            add_vehicle: 'Je hebt nog geen voertuig.  Voeg toe om de lampjes te zien.',
            support: 'Start een gesprek.',
        },
        empty: {
            title: 'Er zijn geen storingslampjes gevonden voor jouw voertuig.',
        },
    },
    reviews: {
        title: 'Reviews',
        intro: 'Wij vinden het altijd leuk om reacties te ontvangen van onze klanten. Bent u tevreden en wilt u dat laten weten?',
        number_of_reviews_12_months: 'Reviews afgelopen maanden',
        average_12_months_rating: 'Gemiddelde afgelopen maanden',
        percentage_recommended: 'Aangeraden door klanten',
        from: 'uit',
        recommend: 'Aanbevolen',
        buttons: {
            previous: 'Vorige',
            next: 'Volgende',
            create: 'Geef uw mening',
        },
    },
    occasions: {
        index: {
            titles: {
                index: 'Het aanbod van ',
                result: ' resultaat gevonden voor bovenstaande filters.',
                results: ' resultaten gevonden voor bovenstaande filters.',
            },
            buttons: {
                more: 'Toon meer occasions',
                loading: 'Occasions ophalen',
            },
        },
        details: {
            buttons: {
                back: 'Alle occasions',
                offer: 'Vraag offerte aan',
                test_drive: 'Vraag proefrit aan',
                trade_in: 'Vraag inruilvoorstel aan',
                back_to_occasion: 'Terug naar occasion',
            },
            tabs: {
                general: 'Basisgegevens',
                technical: 'Technisch',
                history: 'Historie',
                financial: 'Financieel',
                environment: 'Milieu',
                options: 'Opties en accessoires',
                description: 'Omschrijving',
                other: 'Overig',
            },
            titles: {
                details: 'Specificaties van deze ',
                other: 'Alles over deze ',
            },
            table: {
                price: 'Prijs',
                identifier: 'Kenteken',
                buildyear: 'Bouwjaar',
                mileage: 'Km-stand',
                fuel: 'Brandstof',
                transmission: 'Transmissie',
            },
            general_fields: {
                price_with_vat: 'Prijs incl. BTW',
                price_without_vat: 'Prijs excl. BTW',
                tax_deductible: 'BTW verrekenbaar',
                license_plate: 'Kenteken',
                fuel: 'Brandstof',
                color: 'Kleur',
                interior: 'Bekleding',
                number_of_seats: 'Aantal zitplaatsen',
                doors: 'Aantal deuren',
                type: 'Type',
                lease_price: 'Prijs per maand',
                mileage: 'KM-stand',
                build_year: 'Bouwjaar',
                build_month: 'Bouwmaand',
                bodywork: 'Carosserie',
                transmission: 'Transmissie',
                cylinder_capacity: 'Cilinderinhoud',
                number_of_cylinders: 'Aantal cilinders',
                weight: 'Gewicht',
                max_towing_weight: 'Max. trekgewicht',
                power: 'Max. vermogen',
                torque: 'Max. koppel',
                top_speed: 'Topsnelheid',
                acceleration: 'Acceleratie (0 - 100)',
                number_of_gears: 'Aantal versnellingen',
                road_tax: 'Wegenbelasting',
                model_range: 'Modelreeks',
                fuel_consumption_average: 'Gemiddeld verbuik',
                fuel_consumption_city: 'Gemiddeld verbuik stad',
                fuel_consumption_highway: 'Gemiddeld verbuik snelweg',
                co2_emissions: 'Co2 emissie',
                emission_class: 'Emissie klasse',
                energy_label: 'Energie label',
                new_price: 'Nieuwprijs',
                first_owner: 'Eerste eigenaar',
                number_of_owners: 'Aantal eigenaren',
                maintenance_booklets: 'Onderhoudsboekjes aanwezig',
                dealer_maintained: 'Dealeronderhouden',
                date_first_issue: 'Datum eerste uitgifte',
                date_first_admission: 'Datum eerste toelating',
                delivery_costs: 'Opleverkosten',
            },
            leads: {
                types: {
                    offer: 'Offerte',
                    tradein: 'Inruilvoorstel',
                    testdrive: 'Proefrit',
                },
                titles: {
                    request: (args?: Record<string, string>) => `${args?.type} aanvraag`,
                    offer_trade_vehicle_in: 'Wilt u uw voertuig inruilen?',
                    trade_vehicle_in: 'Welk voertuig wilt u inruilen?',
                    date_time: 'Wanneer zou je willen langskomen?',
                    customer_data: 'Wat zijn uw gegevens?',
                    occasion_data: {
                        title: 'Overzicht',
                        brand: 'Merk',
                        model: 'Model',
                        mileage: 'Km-stand',
                        price: 'Prijs',
                    },
                },
                labels: {
                    trade_vehicle_in: 'Ja, ik wil mijn voertuig inruilen',
                },
                license_plate: 'Kenteken',
                mileage: 'KM-stand',
                remarks: 'Opmerkingen',
                thank_you: {
                    title: (args?: Record<string, string>) => `${args?.type} aangevraagd`,
                    body: (args?: Record<string, string>) => (
                        <>
                            Bedankt voor de aanvraag. Je ontvangt een bevestiging per mail.
                            <br />
                            <br />
                            Zodra je aanvraag bekeken is door {args?.name} zal er contect worden opgenomen.
                        </>
                    ),
                },
            },
        },
        filter: {
            buttons: {
                more: 'Alle filters',
                close: 'Sluit filters',
            },
        },
    },
    contact: {
        tabs: {
            general: 'Algemeen',
            address: 'Adresgegevens',
            opening_hours: 'Openingstijden',
        },
        titles: {
            other_data: {
                phone_extra: 'Overige telefoonnummers',
                email_extra: 'Overige e-mailadressen',
                emergency_phone_extra: 'Overige noodnummers',
            },
            call_us_general: 'Bel ons algemene nummer',
            call_us_emergency: 'Bel ons noodnummer',
            make_appointment: 'Maak online een afspraak',
            email_us: 'E-mail ons op',
            general_data: 'Algemene gegevens',
            coc: 'KVK',
            tax: 'BTW',
            no_opening_hours: 'Er zijn geen openingstijden bekend',
        },
        table: {
            address: 'Bezoekadres',
            open: 'Open',
            break: 'Pauze',
            days: {
                today: 'Vandaag',
                tomorrow: 'Morgen',
                monday: 'Maandag',
                tuesday: 'Dinsdag',
                wednesday: 'Woensdag',
                thursday: 'Donderdag',
                friday: 'Vrijdag',
                saturday: 'Zaterdag',
                sunday: 'Zondag',
                closed: 'Gesloten',
            },
        },
        buttons: {
            map: 'Toon route',
        },
    },
    news: {
        detail: {
            buttons: {
                previous: 'Vorige artikel',
                next: 'Volgende artikel',
            },
        },
        index: {
            buttons: {
                more: 'Toon meer nieuws',
                loading: 'Nieuws ophalen',
            },
        },
    },
    onboarding: {
        contact: {
            title: 'Contact gegevens 🤙',
            subtitle: 'Kloppen jouw contactgegevens nog?',
            content_title: 'Jouw contact gegevens',
            fields: {
                email: 'Email',
                phone: 'Telefoonnummer',
            },
            buttons: {
                invalid: 'Nee, ze kloppen niet',
                next: 'Opslaan en doorgaan',
                valid: 'Ja, dit klopt',
            },
        },
        location_details: {
            title: 'Jouw adres 🏡',
            subtitle_address: (args?: Record<string, string>) => `Woon je nog aan de ${args?.address}`,
            subtitle_unknown: 'Zijn jouw adresgegevens nog juist?',
            content_title: 'Jouw adres',
            buttons: {
                invalid: 'Nee, dit klopt niet',
                next: 'Opslaan en doorgaan',
                valid: 'Ja, dit klopt',
            },
            fields: {
                address: 'Straatnaam, huisnummer en toevoeging',
                address_2: 'Postcode en woonplaats',
                street: 'Straatnaam',
                house_number: 'Huisnummer',
                house_number_addition: 'Toevoeging',
                postal_code: 'Postcode',
                city: 'Woonplaats',
            },
        },
        personal_details: {
            title_name: (args?: Record<string, string>) => `Hey ${args?.name} 👋`,
            title_unknown: 'Hallo 👋',
            subtitle: 'Hebben wij nog de juiste gegevens van je?',
            content_title: 'Jouw gegevens',
            buttons: {
                invalid: 'Nee, ze kloppen niet',
                next: 'Opslaan en doorgaan',
                valid: 'Ja, dit klopt',
            },
        },
        privacy_agreement: {
            title: 'Privacy 🔏',
            subtitle: 'Ga je akkoord met onze privacy statement?',
            content_title: 'Privacy',
            content_explanation: (
                <>
                    Om gebruik te kunnen maken van de functionaliteiten van onze APP dient u akkoord te gaan met het{' '}
                    <strong>privacystatement.</strong>
                </>
            ),
            buttons: {
                disagree: 'Ik ga niet akkoord',
                agree: 'Ik ga akkoord',
            },
            modal: {
                title: 'Ik ga niet akkoord',
                explanation: 'Je geeft aan om niet akkoord te gaan met onze privacy statement. Wat wil je doen?',
                logout: 'Uitloggen en mijn gegevens bewaren voor een volgende keer',
                delete: 'Uitloggen en mijn gegevens verwijderen',
                agree: 'Toch wel akkoord gaan en deze app gebruiken',
            },
        },
        vehicles: {
            title: 'Jouw voertuigen 🚗',
            subtitle: 'Zijn dit nog jouw voertuigen?',
            content_title: 'Jouw voertuigen',
            no_vehicles:
                "Er zijn geen voertuigen bekend. Klik op 'voertuig toevoegen' om er een toe te voegen o.b.v. kenteken",
            buttons: {
                add_vehicle: 'Voertuig toevoegen',
                invalid: 'Nee dit klopt niet',
                next: 'Volgende',
                valid: 'Ja, dit klopt',
            },
        },
    },
    appointment: {
        vehicle_select: {
            title: 'Afspraak maken',
            subtitle: (args?: Record<string, string>) => `Wil je een afspraak voor je ${args?.brand} maken?`,
            modals: {
                titles: {
                    select: 'Voertuig selecteren',
                },
            },
            empty: {
                title: 'Geen voertuigen',
                message: 'Je hebt nog geen voertuigen ingesteld. Stel eerst een voertuig in om een afspraak te maken.',
                action: 'Bekijk mijn voertuigen',
            },
            no_vehicle: {
                title: 'Geen voertuig geselecteerd',
                message:
                    'Je hebt geen voertuig geselecteerd om een afspraak te kunnen maken. Selecteer één van je voertuigen.',
            },
            footer: {
                buttons: {
                    select: 'Nee, een ander voertuig',
                    create: 'Voertuig toevoegen',
                    next: 'Ja, dit klopt',
                },
            },
        },
        location_select: {
            title: 'Vestiging',
            subtitle: (args?: Record<string, string>) => `Wil je een afspraak maken bij ${args?.location}?`,
            subtitle_unknown: 'Waar wil je een afpsraak maken?',
            modals: {
                titles: {
                    select: 'Andere vestiging selecteren',
                },
            },
            empty: {
                title: 'Geen vestigingen',
                message: 'Er zijn geen vestigingen bekend.',
            },
            no_location: {
                title: 'Geen vestiging geselecteerd',
                message:
                    'Je hebt geen vestiging geselecteerd om een afspraak te kunnen maken. Selecteer één van de vestigingen.',
            },
            footer: {
                buttons: {
                    select: 'Nee, een andere vestiging',
                    next: 'Ja, dit klopt',
                },
            },
        },
        appointment_details: {
            title: 'Afspraakdetails',
            subtitle: 'Welke afspraak wil je maken?',
            title_appointment: 'Jouw afspraak',
            fields: {
                main_activity: 'Afspraak',
                sub_activities: 'Extra onderhoud',
                replacement_vehicle: 'Vervangend vervoer',
                remarks: 'Opmerkingen',
            },
            footer: {
                buttons: {
                    previous: 'Terug',
                    next: 'Opslaan en verder',
                },
            },
        },
        review_prefilled: {
            title: (args?: Record<string, string>) =>
                `Klopt het dat je een afspraak wil maken voor jouw ${args?.vehicle} bij ${args?.location}`,
            footer: {
                buttons: {
                    select: 'Nee, ga naar selecteren',
                    next: 'Ja, dit klopt',
                },
            },
        },
        date_picker: {
            title: 'Datum',
            subtitle: 'Wanneer kunnen we je verwachten?',
            title_appointment: 'Jouw afspraak',
            legend: {
                status: {
                    available: 'Beschikbaar',
                    partially: 'Bijna vol',
                    unavailable: 'Vol',
                },
            },
            footer: {
                buttons: {
                    previous: 'Terug',
                    next: 'Opslaan en verder',
                },
            },
        },
        time_picker: {
            title: 'Tijdstip',
            subtitle: 'En hoe laat?',
            title_appointment: 'Jouw afspraak',
            fields: {
                time: 'Tijdstip',
            },
            footer: {
                buttons: {
                    previous: 'Terug',
                    next: 'Opslaan en verder',
                },
            },
        },
        mileage: {
            title: 'Kilometerstand',
            subtitle: 'Klopt de onderstaande kilometerstand?',
            title_appointment: (args?: Record<string, string>) => `Kilometerstand van jouw ${args?.brand}`,
            fields: {
                mileage: 'Kilometerstand',
            },
            footer: {
                buttons: {
                    previous: 'Terug',
                    next: 'Opslaan en verder',
                },
            },
        },
        summary: {
            title: 'Bevestigen',
            subtitle: 'Kloppen alle gegevens?',
            title_appointment: 'Jouw afspraak',
            fields: {
                mileage: 'Kilometerstand',
                main_activity: 'Afspraak',
                sub_activities: 'Extra onderhoud',
                replacement_vehicle: 'Vervangend vervoer',
                date_and_time: 'Datum en tijd',
                remarks: 'Opmerkingen',
            },
            footer: {
                buttons: {
                    previous: 'Terug',
                    submit: 'Bevestigen',
                },
            },
        },
        success: {
            title: 'Bedankt voor je afspraak',
            message: `We hebben je afspraakverzoek ontvangen en nemen deze zo snel mogelijk in behandeling.`,
            redirect: 'Je wordt zo doorgestuurd naar Home.',
        },
        select: {
            fields: {
                time: 'tijdstip',
                activity: 'afspraaktype',
                replacement_vehicle: 'vervangend vervoer',
            },
        },
    },
    login: {
        titles: {
            main: 'Inloggen bij',
            email: 'Inloggen met E-mail',
            google: 'Inloggen met Google',
            facebook: 'Inloggen met Facebook',
        },
        fields: {
            email: 'E-mail adres',
        },
        copy: {
            index: 'Login om van alle functies gebruik te maken en direct toegang te hebben tot je gegevens.',
            check_email: 'Bekijk je E-mail voor de login link.',
        },
        buttons: {
            facebook: 'Inloggen met Facebook',
            google: 'Inloggen met Google',
            email: 'Inloggen met E-mail',
            email_link: 'Stuur login link',
            email_back: 'Terug naar home',
        },
    },
    enums: {
        language: {
            nl: 'Nederlands',
            fr: 'Frans',
            de: 'Duits',
            en: 'Engels',
            vls: 'Vlaams',
        },
        country: {
            NL: 'Nederland',
            FR: 'Frankrijk',
            DE: 'Duitsland',
            EN: 'Engeland',
            BE: 'België',
        },
        opening_hours: {
            GENERAL: 'Algemeen',
            WORKSHOP: 'Werkplaats',
            SALES: 'Verkoop',
            RECEPTION: 'Receptie',
            ADMINISTRATION: 'Administratie',
            PLANNER: 'Planner',
        },
        tires: {
            SUMMER_ONLY: 'Zomerbanden',
            WINTER_ONLY: 'Winterbanden',
            SUMMER_AND_WINTER: 'Zomer & winterbanden',
            ALL_SEASON: 'All season',
        },
    },
    widgets: {
        notification_disabled: {
            title: 'Je hebt niet alle notificaties ingeschakeld',
            content: 'Check je instellingen en blijf op de hoogte',
        },
        notification_permission_disabled: {
            title: 'Je hebt nog geen toegang gegeven voor notificaties',
            denied: 'Je hebt de toegang geweigerd voor notificaties',
            content: 'Verleen toegang tot het ontvangen van notificaties',
        },
    },
    general: {
        till: 'tot',
        from_till: 't/m',
        yes: 'Ja',
        no: 'Nee',
        unknown: 'Onbekend',
        non_applicable: 'N.V.T.',
        choose_value: (args?: Record<string, string>) => `Kies een ${args?.name}`,
        select_value: (args?: Record<string, string>) => `Selecteer een ${args?.name}`,
        flash: {
            success: 'De gegevens zijn opgeslagen',
            validation: 'Niet alle gegevens zijn correct ingevuld',
        },
    },
    errors: {
        401: {
            title: 'Ongeautoriseerd',
            description: 'Je bent niet geautoriseerd om de pagina te bekijken.',
        },
        403: {
            title: 'Onbevoegd',
            description: 'Je hebt niet alle rechten om de pagina te bekijken.',
        },
        404: {
            title: 'Pagina niet gevonden',
            description: 'De gevraagde pagina is niet bekend.',
        },
        500: {
            title: 'Er is iets fout gegaan',
            description: 'De aanvraag kon niet worden verwerkt, onze excuses voor het ongemak.',
        },
    },
};
